
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/women_at_work",
      function () {
        return require("private-next-pages/women_at_work/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/women_at_work"])
      });
    }
  